import apiFetch from '../apiFetch'

export default function (id, token) {
  return apiFetch({endPoint: `NivelGenetico/getNivelGenetico?idNivelGenetico=${id}`, method: 'GET', body: null, token: token})
}
